import fetch from 'lib/fetch'
import { apiV3BLLaunchdDarklyMetricPath } from 'lib/urls'
import { LDContext } from './ldContext'
import { isPrerenderUserAgent } from '../isPrerenderUserAgent'

// Tracks metric (which are essentially events that are used as conversion events)
// in LaunchDarkly
// https://docs.launchdarkly.com/sdk/features/events/

export const ldTrackMetric = async (
  context: LDContext,
  eventName: string,
  eventProperties: boolean
) => {
  if (
    typeof window === 'undefined' ||
    !context?.key ||
    context?.key === 'undefined' ||
    context?.key === '' ||
    isPrerenderUserAgent()
  ) {
    return
  }
  const { client } = window.ldClient
  try {
    await client.identify(context)
    client.track(eventName, eventProperties)
  } catch (_e) {
    // Do nothing
  }
}

// This function will use the babylist API as a proxy and will not use the LD client
export const ldTrackMetricV2 = (eventName: string) => {
  if (typeof window === 'undefined' || isPrerenderUserAgent()) {
    return
  }

  const data = {
    event: eventName,
  }

  fetch(apiV3BLLaunchdDarklyMetricPath, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  })
}
